import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import axiosService from '../../../../../../utils/AxiosService'
import { toastSuccess } from '../../../../../FormComponents/Toasts'
import Modal from '../../../../../Modal/Modal'

export default observer(function RemoveInfluencerModal({ modalOpen, setModalOpen, campaignAuthentication }) {
  const { id } = useParams()
  const { campaignState, authentications, loadInfluencers, loadCampaignScenarios } = useContext(CampaignContext)

  const removeInfluencer = () => {
    axiosService.delete(`/api/project_manager/campaigns/${id}/campaign_authentications/${campaignAuthentication.campaign_authentication_id}`)
    .then(deletedCampaignAuthentication => {
      loadInfluencers()
      loadCampaignScenarios()
      toastSuccess('Influencer removed')
      campaignState.campaignAuthentications = authentications.filter(authentication => +deletedCampaignAuthentication.id !== +authentication.campaign_authentication_id)
      setModalOpen(false)
    })
  }

  return (
    <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
      <Modal.Header>Remove Influencer</Modal.Header>
      <Modal.Body>
        <div style={{ width: '100%' }}>
          <p className="font-bold text-xl text-center">Are you sure you want to delete this influencer from this campaign?</p>
          <p className="text-center">All of its actions and drafts will be deleted too.</p>
          <div className="flex justify-between">
            <button className="rb-btn-cancel rounded-xl px-4 py-2 text-sm font-bold" onClick={() => setModalOpen(false)}>Cancel</button>
            <button className="bg-red-500 text-white border-1 rounded-xl px-4 py-2 text-sm font-bold" onClick={removeInfluencer}>Confirm</button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
})